module.exports = __webpack_public_path__ + "img/book-mark.ef53b2ae.svg";